export default "/images/3320397fdbc1855bc72b029714dab443.avif";